import { render, staticRenderFns } from "./Receipients.vue?vue&type=template&id=2ceeb1cc"
import script from "./Receipients.vue?vue&type=script&lang=ts"
export * from "./Receipients.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports